
<div [class.show]="isHighlighted" class="root-wrapper">

    <router-outlet></router-outlet>
    
</div>